import ApiService from "./ApiService";
import { stringify } from "querystring";

const ENDPOINTS = {
  MERCHANT: "merchants/me/",
  PUBLIC_MERCHANT: "merchants/public-merchant",
};

class MerchantService extends ApiService {
  getMerchant = (payload) => {
    return this.apiClient.get(`${ENDPOINTS.MERCHANT}?${stringify(payload)}`);
  };

  getPublicMerchant = (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.PUBLIC_MERCHANT}?${stringify(payload)}`
    );
  };
}

export default new MerchantService();
